import React, { useState, useRef, useEffect } from "react";
import { Rating } from "react-simple-star-rating";
import { FiUpload } from "react-icons/fi";
import { Modal } from "antd";
import styles from "./style.module.css";
import img from "../../assets/images/1593886786277.jpg";
import { disputeOfferSlot, uploadFile } from "../../services/auth";
import { baseUrl } from "../../services/api";
import toast, { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css"; // Import CSS for toast notifications

const FeedbackModal = ({ isModalVisible, setIsModalVisible, data }) => {
  const [isTeacher, setIsTeacher] = useState(true);
  const [form, setForm] = useState({
    isDisputed: false,
    teacherRating: 0,
    studentRating: 0,
    adminReview: "",
    adminReviewFile: "",
  });
  const [profileImage, setProfileImage] = useState(img);

  useEffect(() => {
    setForm({
      isDisputed: !!data?.["offerSlots.isDisputed"],
      teacherRating: data?.["offerSlots.teacherRating"] || 0,
      studentRating: data?.["offerSlots.studentRating"] || 0,
      adminReview: data?.["offerSlots.review"] || "",
      adminReviewFile: "",
    });
  }, [data]);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleSelection = () => {
    setIsTeacher(!isTeacher);
  };

  const handleReset = () => {
    setForm({
      isDisputed: false,
      teacherRating: 0,
      studentRating: 0,
      adminReview: "",
      adminReviewFile: "",
    });
  };

  const handleSubmit = async () => {
    if (!data?.["offerSlots.id"]) return;
    try {
      await disputeOfferSlot(form, data?.["offerSlots.id"]);
      toast.success("Feedback saved successfully!");
      handleCancel();
      handleReset();
    } catch (error) {
      console.error("Failed to save feedback:", error);
      toast.error("Failed to save feedback. Please try again.");
    }
  };

  const branchLogo = useRef(null);

  const uploadPicker = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      console.log("Selected file:", file);

      const formData = new FormData();
      formData.append("file", file);

      const { status, data } = await uploadFile(formData);
      console.log("Upload status:", status);
      console.log("Response data:", data);

      if (status === 200 || status === 201) {
        const imageUrl = `${baseUrl}${data.data.url}`;
        console.log("Constructed image URL:", imageUrl, data.data.url);
        setProfileImage(imageUrl);
        setForm((prevForm) => ({ ...prevForm, adminReviewFile: imageUrl }));
        toast.success("File uploaded successfully!"); // Success toast
      } else {
        throw new Error(`Unexpected response status: ${status}`);
      }
    } catch (error) {
      console.error("File upload failed:", error);
      toast.error("File upload failed. Please try again."); // Error toast
    }
  };

  return (
    <>
      <Modal
        title="Feedback"
        footer={null}
        closable
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={750}
        style={{
          top: 80,
        }}
      >
        <div className="py-3">
          <div className="row d-flex px-4">
            <div className="col-6">
              <button
                style={{ padding: "10px 0px" }}
                onClick={() => handleSelection()}
                className={`btn mb-3 shadow-sm px-5 ${
                  isTeacher ? "btn-primary primary_bg_color" : ""
                }`}
                type="button"
              >
                <div className="d-flex">
                  <div className="text-left pl-2">
                    <span className="fs_12">Feedback Teacher</span>
                    <br />
                    <span className="fs_14 font-weight-bold">
                      {data?.["teacher.fullName"] || "N/A"}
                    </span>
                  </div>
                </div>
              </button>
            </div>
            <div className="col-6">
              <button
                style={{ padding: "10px 0px" }}
                onClick={() => handleSelection()}
                className={`btn ${
                  !isTeacher ? "btn-primary primary_bg_color" : ""
                } shadow-sm mb-3 px-5`}
                type="button"
              >
                <div className="d-flex">
                  <div className="text-left pl-2">
                    <span className="fs_12">Feedback Student</span>
                    <br />
                    <span className="fs_14 font-weight-bold">
                      {data?.["student.fullName"] || "N/A"}
                    </span>
                  </div>
                </div>
              </button>
            </div>
          </div>

          {/* Ratings */}
          <div className="row mx-2">
            <div className="col-6 d-flex">
              <div className="pr-3">
                <Rating
                  className="ml-2"
                  size={20}
                  initialValue={form.teacherRating}
                  onClick={(rating) => {
                    setForm({ ...form, teacherRating: rating });
                  }}
                />
              </div>
              <div className="">Give Rating</div>
            </div>
            <div className="col-6 d-flex">
              <div className="pr-3">
                <Rating
                  size={20}
                  initialValue={form.studentRating}
                  onClick={(rating) => {
                    setForm({ ...form, studentRating: rating });
                  }}
                />
              </div>
              <div className="">Give Rating</div>
            </div>
          </div>

          {/* Text Area */}
          <div className="row px-4 mx-2 text-left pt-3">
            <div className="form-group p-0">
              <label
                className="font-weight-bold"
                htmlFor="exampleFormControlTextarea1"
              >
                Write a review
              </label>
              <textarea
                value={form.adminReview}
                onChange={(e) => {
                  setForm({ ...form, adminReview: e.target.value });
                }}
                className={`form-control shadow ${styles.border_color}`}
                id="exampleFormControlTextarea1"
                rows="5"
              ></textarea>
            </div>
            <label
              className={`d-flex p-2 w-50 rounded justify-content-between align-items-center ${styles.border_color} ${styles.cursor_pointer}`}
              onClick={() => {
                branchLogo.current.click();
              }}
            >
              <div className="font-weight-bold text-dark">
                Upload Photo and Videos
              </div>
              <FiUpload style={{ fontSize: "20px" }} />
            </label>
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={uploadPicker}
              ref={branchLogo}
            />
            <div className="d-flex justify-content-between align-items-end">
              <div className="ml-2">
                <input
                  checked={form.isDisputed}
                  onChange={(e) => {
                    setForm({ ...form, isDisputed: e.target.checked });
                  }}
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Mark as Disputed ?
                </label>
              </div>
              <div className="">
                <button
                  onClick={handleCancel}
                  className="btn btn_outlined fs_12 btn-sm text-danger px-4 py-2 mr-2"
                >
                  Cancel
                </button>
                <button
                  className="btn btn_contained_black fs_12 btn-sm text-white px-4 py-2"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Toaster />
    </>
  );
};

export default FeedbackModal;
